(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    module.directive('taskStates', function () {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/tasks/templates/task-states-bar.template.html',
            scope: {
                taskState: '=', 
                isToDo: '@?', //default false -> daytasks
                isIntern : '@?' //default false 
            },
            controller: 'TaskStatesBarController',
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    });

})();